import Modal from '@organisms/Modal/Modal';
import Spinner from '@molecules/Spinner/Spinner';
import Text from '@atoms/Text/Text';
import useTranslation from 'next-translate/useTranslation';

const ProcessingOrderModal = () => {
  const { t } = useTranslation('checkoutpage');

  return (
    <Modal size="small">
      <Spinner color="primary" size={32} />
      <Text size="medium" type="body" style={{ marginTop: 24 }}>
        {t('processingOrderModal->text')}
      </Text>
    </Modal>
  );
};

export default ProcessingOrderModal;
